import { RouterActionTypes, SET_ROUTE } from './types';

export const setRoute = (payload: string, params, path = ''): RouterActionTypes => ({
  type: SET_ROUTE,
  payload,
  path,
  ...(params && { params }),
});
